/**
 * CRM Multi-Compagnia · Dashboard - KpiCard
 * KPI card con valore principale, sub-label, delta opzionale (%, +/-) e icona.
 */
import { TrendingUp, TrendingDown, Minus } from "lucide-react";

export default function KpiCard({ icon: Icon, label, value, subValue, deltaPct, color = "emerald", testid, onClick }) {
  const colors = {
    emerald: "bg-emerald-50 text-emerald-600 border-emerald-100",
    blue: "bg-blue-50 text-blue-600 border-blue-100",
    violet: "bg-violet-50 text-violet-600 border-violet-100",
    amber: "bg-amber-50 text-amber-600 border-amber-100",
    rose: "bg-rose-50 text-rose-600 border-rose-100",
    orange: "bg-orange-50 text-orange-600 border-orange-100",
  };
  const cls = colors[color] || colors.emerald;
  const Trend = deltaPct == null ? Minus : deltaPct > 0 ? TrendingUp : TrendingDown;
  const trendColor = deltaPct == null ? "text-zinc-400" : deltaPct > 0 ? "text-emerald-600" : "text-rose-600";

  return (
    <button
      onClick={onClick}
      disabled={!onClick}
      className={`bg-white border border-zinc-200 rounded-xl p-4 text-left w-full transition ${onClick ? "hover:border-emerald-300 hover:shadow-sm cursor-pointer" : "cursor-default"}`}
      data-testid={testid}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0 flex-1">
          <p className="text-[10px] text-zinc-500 uppercase tracking-wider font-medium">{label}</p>
          <p className="text-2xl font-semibold text-zinc-900 mt-1 truncate">{value}</p>
          {subValue && (
            <p className="text-[11px] text-zinc-500 mt-0.5 truncate">{subValue}</p>
          )}
          {deltaPct != null && (
            <div className={`flex items-center gap-1 mt-1.5 ${trendColor}`}>
              <Trend className="w-3 h-3" />
              <span className="text-[11px] font-medium">
                {deltaPct > 0 ? "+" : ""}{deltaPct}% vs anno prec.
              </span>
            </div>
          )}
        </div>
        <div className={`w-9 h-9 rounded-lg ${cls} border flex items-center justify-center flex-shrink-0`}>
          <Icon className="w-4 h-4" />
        </div>
      </div>
    </button>
  );
}
